import script from "./UmbrellaCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./UmbrellaCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./UmbrellaCampaigns.vue?vue&type=style&index=0&id=371adf8a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-371adf8a"]])

export default __exports__